/**
 * SSR injection tokens — local replacements for @nguniversal/express-engine/tokens.
 * Provides REQUEST and RESPONSE tokens for Server-Side Rendering contexts.
 * These are @Optional() in all components so they resolve to null in the browser.
 */
import { InjectionToken } from '@angular/core';
import { Request, Response } from 'express';

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');
